import React, { useState } from "react";
import Lightbox from "react-image-lightbox";

const LightBox = ({ images, isOpen, setIsOpen }) => {
  const [index, setIndex] = useState(0);

  return (
    <>
      {isOpen && (
        <Lightbox
          mainSrc={images[index]}
          nextSrc={images[(index + 1) % images.length]}
          prevSrc={images[(index + images.length - 1) % images.length]}
          onCloseRequest={() => setIsOpen(false)}
          onMovePrevRequest={() => {
            setIndex((index) => {
              return (index + images.length - 1) % images.length;
            });
          }}
          onMoveNextRequest={() => {
            setIndex((index) => {
              return (index + 1) % images.length;
            });
          }}
        />
      )}
    </>
  );
};

export default LightBox;
